export default "__VITE_ASSET__DUD4aFUI__"